<template>
  <v-container fluid>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Select Week"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                no-title
                scrollable
                @input="$refs.menu.save(date)"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
            v-model="mealType"
            :items="mealTypes"
            label="Meal Time"
            outlined
            ></v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-alert type="info" outlined>
              Available Points: {{ availablePoints }}
            </v-alert>
          </v-col>
        </v-row>


        <v-data-table
          :headers="headers"
          :items="mealPlan"
          :items-per-page="7"
          class="elevation-1"
        >
          <template v-slot:item.date="{ item }">
            {{ formatDate(item.date) }}
          </template>
          <template v-slot:item.mealType="{ item }">
            <v-select
              v-model="item.mealType"
              :items="mealComboTypes"
              label="Meal Type"
              @change="updateMealOptions(item)"
            ></v-select>
          </template>
          <template v-slot:item.combo="{ item }">
            <v-select
              v-model="item.combo"
              :items="getComboOptions(item)"
              label="Combo"
              :disabled="!item.mealType"
              @change="updateComboDetails(item)"
            ></v-select>
          </template>
          <template v-slot:item.comboItems="{ item }">
            <v-chip-group column>
              <v-chip
                v-for="(comboItem, index) in item.comboItems"
                :key="index"
                small
                :color="getChipColor(comboItem)"
              >
                {{ comboItem }}
              </v-chip>
            </v-chip-group>
          </template>
          <template v-slot:item.points="{ item }">
            {{ item.points }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              small
              color="primary"
              @click="saveMealSelection(item)"
              :disabled="!item.mealType || !item.combo || !canEditOrSave(item.date)" 
            >
            {{ item.saved ? 'Edit' : 'Save' }}
            </v-btn> 
            <!-- here we need update that once the saved then edit , but contition is that users are save or edit  last friday before next monday to saturday -->
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <!-- <v-dialog v-model="customizationDialog" max-width="800px">
      <v-card>
        <v-card-title>Customize Your Meal</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6" v-for="(category, categoryName) in mealItems" :key="categoryName">
              <v-subheader>{{ categoryName.toUpperCase() }}</v-subheader>
              <v-list>
                <v-list-item v-for="item in category" :key="item.id">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle>Points: {{ item.points }} per {{ item.unit }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon @click="removeItemFromMeal(item)" :disabled="!currentMeal.items.find(i => i.id === item.id)">
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>
                    <span class="mx-2">{{ (currentMeal.items.find(i => i.id === item.id) || {}).quantity || 0 }}</span>
                    <v-btn icon @click="addItemToMeal(item)" :disabled="(currentMeal.items.find(i => i.id === item.id) || {}).quantity >= item.maxOrder">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
          <v-divider class="my-4"></v-divider>
          <v-row>
            <v-col cols="12">
              <h3>Total Points: {{ currentMeal.totalPoints }}</h3>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="customizationDialog = false">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="saveMeal">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <v-dialog v-model="customizationDialog" max-width="600px">
      <v-card>
        <v-toolbar flat color="primary">
            <v-card-title>Customize Your Meal</v-card-title>
            <v-spacer></v-spacer>
            <v-btn icon color="red" @click="closeCustomizationDialog" ><v-icon>mdi-close</v-icon></v-btn>         
        </v-toolbar>
        <v-card-text class="mt-2" >
            <v-row >
              <v-col col="6">
                <v-select v-model="customMeal.Flatbreads" 
                :items="['None', 'Chapathi', 'Poratta','Roti','Nana','Kuboos']" 
                label="Flatbreads" outlined></v-select>
              </v-col>
              <v-col col="6">
                <v-text-field v-model="customMeal.FlatbreadsNos" type="number" 
                outlined :label="`Number of ${customMeal?.Flatbreads }`"  
                :disabled="!customMeal.Flatbreads"></v-text-field>
              </v-col>
            </v-row >
            <v-row>
              <v-col col="6">
                <v-select v-model="customMeal.rice" chips
                :items="['None', 'Barik Rice', 'Motta Rice']" label="Rice" outlined></v-select>
              </v-col>
              <v-col col="6">
                <span class="subheading">rice portion</span>
                <v-chip-group
                  v-model="customMeal.rice_portion"
                  active-class="primary--text text--accent-4"
                  mandatory
                  outlined
                  >
                  <v-chip x-small>Small</v-chip>
                  <v-chip small>Half</v-chip>
                  <v-chip>Standard</v-chip>
                  <v-chip Large>extra</v-chip>
                </v-chip-group>                
              </v-col>
            </v-row>
            <v-row>
              <v-col col="6">
                <v-select v-model="customMeal.curry" :items="curryOptions" label="Curry" outlined ></v-select>
              </v-col>
              <v-col col="6">
                <v-chip-group
                  v-model="customMeal.curry_portion"
                  active-class="primary--text text--accent-4"
                  mandatory
                  outlined
                >
                  <v-chip x-small>Small</v-chip>
                  <v-chip small>Half</v-chip>
                  <v-chip>Standard</v-chip>
                  <v-chip large>Extra</v-chip>
              </v-chip-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col col="6">
                  <v-select v-model="customMeal.dry" :items="dryOptions" label="Dry Fry" outlined></v-select>
              </v-col>
              <v-col col="6">
                  <v-text-field v-model="customMeal.dryNos" type="number" label="Number of Dry" outlined :disabled="!customMeal.dry"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
            <v-col col="6"><v-checkbox v-model="customMeal.dalCurry" label="Dal Curry"></v-checkbox></v-col>
            <v-col col="6"> <v-checkbox v-model="customMeal.salad" label="Salad"></v-checkbox></v-col>
            <v-col col="6"><v-checkbox v-model="customMeal.curd" label="Curd"></v-checkbox></v-col>
            <v-col col="6"><v-checkbox v-model="customMeal.dessert" label="Dessert"></v-checkbox></v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
            <v-chip color="success" outlined class="font-weight-bold">Credits: {{customMeal.points}} points</v-chip>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text outlined @click="closeCustomizationDialog">Cancel</v-btn>
          <v-btn color="blue darken-1" text outlined @click="saveCustomization">Add Combo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :timeout="3000" :color="snackbarColor">
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    menu: false,
    date: new Date().toISOString().substr(0, 10),
    mealType:'Lunch',
    mealTypes: ['BreakFast', 'Lunch', 'Dinner', 'Other'],
    headers: [
      { text: 'Date', value: 'date' },
      { text: 'Meal Type', value: 'mealType' },
      { text: 'Combo', value: 'combo' },
      { text: 'Combo Items', value: 'comboItems' },
      { text: 'Points', value: 'points' },
      { text: 'Actions', value: 'actions', sortable: false }
    ],
    mealPlan: [],
    mealComboTypes: ['Chapathi - Vegetarian', 'Barik Rice - Vegetarian', 'Motta Rice - Vegetarian', 'Chapathi - Non-Vegetarian', 'Barik Rice - Non-Vegetarian', 'Motta Rice - Non-Vegetarian'],
    combos: {
      'Chapathi - Vegetarian': ['Combo 1', 'Combo 2', 'Combo 3', 'Customize'],
      'Barik Rice - Vegetarian': ['Combo 1', 'Combo 2', 'Combo 3', 'Customize'],
      'Motta Rice - Vegetarian': ['Combo 1', 'Combo 2', 'Combo 3', 'Customize'],
      'Chapathi - Non-Vegetarian': ['Combo', 'Customize'],
      'Barik Rice - Non-Vegetarian': ['Combo', 'Customize'],
      'Motta Rice - Non-Vegetarian': ['Combo', 'Customize']
    }, //here no need of seperate   mealComboTypes and  combos  , make it combined and can be selected either pre exisitning combo selected custom combo
    comboDetails: {
      'Combo 1': {
        items: ['Chapathi (3)', 'Vegetarian Curry', 'Vegetarian Dry', 'Dal Curry', 'Salad', 'Curd', 'Dessert'],
        points: 10
      },
      'Combo 2': {
        items: ['Chapathi (3)', 'Egg Curry', 'Egg Dry', 'Dal Curry', 'Salad', 'Curd', 'Dessert'],
        points: 12
      },
      'Combo 3': {
        items: ['Chapathi (3)', 'Non-Veg Curry', 'Non-Veg Dry', 'Dal Curry', 'Salad', 'Curd', 'Dessert'],
        points: 15
      },
      'Combo': {
        items: ['Chapathi (3)', 'Non-Veg Curry', 'Non-Veg Dry', 'Dal Curry', 'Salad', 'Curd', 'Dessert'],
        points: 15
      }
    },
    snackbar: false,
    snackbarText: '',
    snackbarColor: 'success',
    customizationDialog: false,
    customMeal: {
      chapathi: false,
      rice: 'None',
      curry: '',
      dry: '',
      dalCurry: false,
      salad: false,
      curd: false,
      dessert: false,
      points: 0
    },
    curryOptions: ['Vegetarian Curry', 'Egg Curry', 'Non-Veg Curry'],
    dryOptions: ['Vegetarian Dry', 'Egg Dry', 'Non-Veg Dry'],
    availablePoints: 70, // 10 points per day for a week
    currentCustomizationIndex: null
  }),

  watch: {
    date() {
      this.generateMealPlan();
    },
    customMeal: {
      deep: true,
      handler() {
        this.calculateCustomMealPoints();
      }
    }
  },

  mounted() {
    this.generateMealPlan();
  },

  methods: {
    generateMealPlan() {
      const startDate = new Date(this.date);
      this.mealPlan = Array.from({ length: 7 }, (_, i) => {
        const currentDate = new Date(startDate);
        currentDate.setDate(startDate.getDate() + i);
        return {
          date: currentDate,
          mealType: '',
          combo: '',
          comboItems: [],
          points: 0,
          customized: false,
          saved: false
        };
      });
    },

    formatDate(date) {
      return new Date(date).toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' }); //here week day need  to be first 3 letters like Mon for Monday 
    },

    getComboOptions(item) {
      return this.combos[item.mealType] || [];
    },

    updateMealOptions(item) {
      item.combo = '';
      item.comboItems = [];
      item.points = 0;
      item.customized = false;
    },

    updateComboDetails(item) {
      if (item.combo === 'Customize') {
        this.openCustomizationDialog(item);
      } else if (item.combo && this.comboDetails[item.combo]) {
        item.points = this.comboDetails[item.combo].points;
        item.comboItems = this.comboDetails[item.combo].items;
        item.customized = false;
      }
    },

    openCustomizationDialog(item) {
      this.currentCustomizationIndex = this.mealPlan.indexOf(item);
      this.customMeal = {
        chapathi: item.mealType.includes('Chapathi'),
        rice: item.mealType.includes('Barik') ? 'Barik Rice' : (item.mealType.includes('Motta') ? 'Motta Rice' : 'None'),
        curry: '',
        dry: '',
        dalCurry: true,
        salad: true,
        curd: true,
        dessert: true,
        points: item.points
      };
      this.customizationDialog = true;
    },

    closeCustomizationDialog() {
      this.customizationDialog = false;
      this.currentCustomizationIndex = null;
    },

    saveCustomization() {
      if (this.currentCustomizationIndex !== null) {
        const item = this.mealPlan[this.currentCustomizationIndex];
        item.points = this.customMeal.points;
        item.customized = true;
        item.combo = 'Custom';
        item.comboItems = this.getCustomComboItems();
      }
      this.closeCustomizationDialog();
    },

    getCustomComboItems() {
      const items = [];
      if (this.customMeal.chapathi) items.push('Chapathi (3)');
      if (this.customMeal.rice !== 'None') items.push(this.customMeal.rice);
      if (this.customMeal.curry) items.push(this.customMeal.curry);
      if (this.customMeal.dry) items.push(this.customMeal.dry);
      if (this.customMeal.dalCurry) items.push('Dal Curry');
      if (this.customMeal.salad) items.push('Salad');
      if (this.customMeal.curd) items.push('Curd');
      if (this.customMeal.dessert) items.push('Dessert');
      return items;
    },

    calculateCustomMealPoints() {
      let points = 0;
      if (this.customMeal.chapathi) points += 3;
      if (this.customMeal.rice !== 'None') points += 3;
      if (this.customMeal.curry) points += 3;
      if (this.customMeal.dry) points += 2;
      if (this.customMeal.dalCurry) points += 1;
      if (this.customMeal.salad) points += 1;
      if (this.customMeal.curd) points += 1;
      if (this.customMeal.dessert) points += 1;
      this.customMeal.points = points;
    },

    saveMealSelection(item) {
      // Here you would typically send this data to your backend
      console.log('Saving meal selection:', item);
      item.saved = true;
      this.snackbarText = `Meal saved for ${this.formatDate(item.date)}`;
      this.snackbarColor = 'success';
      this.snackbar = true;
      this.updateAvailablePoints();
    },

    updateAvailablePoints() {
      const usedPoints = this.mealPlan.reduce((total, meal) => total + meal.points, 0);
      this.availablePoints = 70 - usedPoints; // 70 is the total points for a week (10 per day)
    },

    getChipColor(comboItem) {
      if (comboItem.includes('Vegetarian')) return 'green';
      if (comboItem.includes('Egg')) return 'orange';
      if (comboItem.includes('Non-Veg')) return 'red';
      return 'default';
    },

    canEditOrSave(date) {
    const today = new Date();
    const selectedDate = new Date(date);
    
    // Set time to start of day for consistent comparisons
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);

    // Calculate the start of next week (next Monday)
    const nextMonday = new Date(today);
    nextMonday.setDate(today.getDate() + ((1 + 7 - today.getDay()) % 7));

    // Calculate the Friday of the selected week
    const fridayOfSelectedWeek = new Date(selectedDate);
    fridayOfSelectedWeek.setDate(selectedDate.getDate() + ((5 + 7 - selectedDate.getDay()) % 7));

    // Check if the selected date is in the next week and not after Friday
    return selectedDate >= nextMonday && selectedDate <= fridayOfSelectedWeek && today <= fridayOfSelectedWeek;
  }
  }
};
</script>